(() => {
  if (window.jewelpaRingSizeReady) return;
  window.jewelpaRingSizeReady = true;

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.product-ring-size__option input')) return;
    const output = input.closest('.product-ring-size')?.querySelector('.product-ring-size__selected');
    if (output) output.textContent = input.value;
  });
})();
